// Only fresh transport responses; in-flight requests retain their account generation.
let generation = 0;
let owner = null;
const listeners = new Set();
export const setMilestoneOwner = (nextOwner) => {
  if (owner !== nextOwner) { owner = nextOwner; generation += 1; }
};
export const getMilestoneResponseGeneration = () => generation;
export const subscribeMilestoneResponses = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};
export const publishMilestoneResponse = (payload, requestGeneration) => {
  if (requestGeneration !== generation || payload?.success === false) return;
  const events = payload?.app_resources?.metadata?.milestone_events;
  if (Array.isArray(events) && events.length) listeners.forEach((listener) => listener(events));
};
